module.exports = __webpack_public_path__ + "img/the-cottages-sign.92394f19.webp";